import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/common/confetti.svg")